import Back from '../../components/common/BackComp'
import tipImg from "@/assets/images/attribute/tip.svg"
import mining_icon from '@/assets/images/mining/mining_icon.png'
import standardPool_bg from '@/assets/images/mining/standardPool_bg.png'
import mintStarImg from '@/assets/images/mining/mint_star.png'
import mintPoolImg from '@/assets/images/mining/mint_pool.png'
import NFTPool from '@/assets/images/mining/NFTPool_bg.png'
import starImg from '@/assets/images/rules/star.png'
import recordImg from '@/assets/images/mining/record.png'
import speedImg from '@/assets/images/mining/total.svg'
import speedwhiteImg from '@/assets/images/mining/total.svg'
import personImg from '@/assets/images/mining/person.png'
import star from '@/assets/images/mining/star.svg'

import VIPPool_bg from '@/assets/images/mining/VIPPool_bg.png'
import RulesDialog from '../../components/RulesDialog'
import ruleText from '../../text/rulesText1.tsx'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getPools, postStandardPay, getMiningPayLink, postNftPoolPay } from '@/api/mining'
import { FormattingTwoNumber } from '../../utils'
import PromptDialog from '../../components/PromptDialog'
import PayDialog from '../../components/common/PayDialog'
import { getShopPayConfig } from "@/api/shop.js"
import { Toast } from 'react-vant'
import VIPMiningPoolPay from '../../components/common/VIPMiningPoolPay'
import CountDownComp from '../../components/CountDown'
import { useTranslation } from 'react-i18next'

const Mining = () => {
  const { t } = useTranslation();
  const miningRules = ruleText().miningRules
  const [rulesDialog, setRulesDialog] = useState(false)
  const [poolData, setPoolData] = useState<any>({})
  const [currentTime, setCurrentTime] = useState<any>({})
  const [promptDialog, setPromptDialog] = useState(false)
  const [prompt, setPrompt] = useState(false)
  const [showPayDialog, setShowPayDialog] = useState(false)
  const [promptText, setPromptText] = useState('')
  const [payLink, setPayLink] = useState([])
  const [type, setType] = useState(0)
  const navigate = useNavigate()

  const getData = async () => {
    const { data, msg, code } = await getPools()
    if (code == '0') {
      setPoolData(data)
      const date = new Date();
      const timestamp = date.getTime();
      setCurrentTime(Math.floor(timestamp / 1000))
      return data
    } else {
      setPrompt(true)
      setPromptText(t("other.neterror"))
    }
  }

  const getPayLink = async () => {
    const toast = Toast.loading({
      message: t("other.loading"),
      forbidClick: true,
      duration: 0
    })
    try {
      const { code, data, msg } = await getShopPayConfig(12)
      if (code == 0) {
        setPayLink(data.map((el: any) => { return { ...el, title: "VIP Mining Pool", description: 'Do you want to Join the VIP Mining Pool in TestStarAI for 18 stars?' } }))
      } else {
        setPromptDialog(true)
        setPromptText(t("other.neterror"))
      }
      toast.clear()
    } catch (e) {
      toast.clear()
    }
  }

  useEffect(() => {
    getPayLink()
    getData()
  }, [])

  const standardTime = useMemo(() => {
    let num = ((currentTime - poolData?.standard?.start_time_uinx) / (poolData?.standard?.end_time_uinx - poolData?.standard?.start_time_uinx))
    return num > 1 ? Math.floor(1 * 100) : Math.floor(num * 100)
  }, [currentTime])

  const vipTime = useMemo(() => {
    let num = ((currentTime - poolData?.vip?.start_time_uinx) / (poolData?.standard?.end_time_uinx - poolData?.vip?.start_time_uinx))
    return num > 1 ? Math.floor(1 * 100) : Math.floor(num * 100)
  }, [currentTime])

  return (
    <div className='px-4 relative h-[100vh] overflow-auto pt-[53px]'>
      <Back background='#071919' position={true} title={t("mining.mining")} callback={() => { navigate('/cards?type=Mine') }}></Back>
      <img src={tipImg} onClick={() => {
        setRulesDialog(true)
      }} className=' md:absolute max-md:fixed top-3 z-[1001] right-4' alt="" />

      <div className="h-[200px] w-full bg-[#113A38] my-[10px] rounded-[10px] px-[12px] py-[10px]">
        <div className='w-full flex items-start'>
          <img className=' w-[18px] h-[18px]' src={mining_icon} alt="" />
          <span className='text-white text-base ml-1'>{t("mining.my_mining_profits")}:</span>
        </div>
        <div className='text-[20px] leading-6 text-[#fff] font-bold flex  justify-center  my-[15px] items-end'>
          <p className='text-style-6 !text-[30px] font-bold !leading-[28px] flex items-center gap-1 pr-[10px]'> {FormattingTwoNumber(((poolData?.standard_profits?.profits || 0) + (poolData?.vip_profits?.profits || 0) + (poolData?.nft_profits?.profits || 0)))} </p>
          <p className='text-style-6 !text-[14px] !leading-[18px]'> $ </p>
          <p className='text-style-6 !text-[20px] font-bold !leading-[22px]  pr-[10px]'> SAI </p>
        </div>
        <div className='grid grid-cols-3 h-[98px]'>
          <div className='flex flex-col'>
            <img className='h-[23px] w-full' src={mintStarImg} alt="" />
            <div className='flex flex-col items-center justify-center h-[100%]'>
              <div className='text-[20px] leading-6 text-[#fff] font-bold flex items-end  justify-center'>
                <p className='text-style-6 !text-[20px] font-bold !leading-[18px] pr-[8px]'> {FormattingTwoNumber(poolData?.standard_profits?.profits || 0)} </p>
                <p className='text-style-6 !text-[12px] !leading-[16px]'> $ </p>
                <p className='text-style-6 !text-[14px] font-bold !leading-[16px]'> SAI </p>
              </div>
              <div className='mt-2'>
                <span className='text-white text-base'>{t("mining.standard_pool")}</span>
              </div>
            </div>
          </div>
          <div className='flex justify-center items-center'>
            <img className='w-[96px] h-[86px]' src={mintPoolImg} alt="" />
          </div>
          <div className='flex flex-col'>
            <img className='h-[23px] w-full' src={mintStarImg} alt="" />
            <div className='flex flex-col items-center justify-center h-[100%]'>
              <div className='text-[20px] leading-6 text-[#fff] font-bold flex items-end  justify-center'>
                <p className='text-style-6 !text-[20px] font-bold !leading-[18px] pr-[8px]'>{FormattingTwoNumber(poolData?.vip_profits?.profits || 0)} </p>
                <p className='text-style-6 !text-[12px] !leading-[16px]'> $ </p>
                <p className='text-style-6 !text-[14px] font-bold !leading-[16px]'> SAI </p>
              </div>
              <div className='mt-2'>
                <span className='text-white text-base'>{t("mining.vip_pool")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='flex items-start'>
        <img className='w-[14px] h-[13px] mt-[2px]' src={starImg} alt="" />
        <p className='text-white text-sm flex-1 text-left ml-1'>{t("mining.equal_share")}
        </p>
      </div>

      <div>
        <div className={`flex justify-between items-center mt-[30px] pr-[12px]`}>
          <div className='w-[120px] text-white'>{t("mining.phase")} {poolData?.mining_sn}-1</div>
          {
            currentTime < poolData?.standard?.start_time_uinx ?
              <CountDownComp endHandle={async (val: number) => {
                if (Math.floor(Math.abs(val / 1000)) < 1) {
                  await getData()
                }

              }} date={poolData?.standard?.start_time}></CountDownComp>
              :

              <CountDownComp endHandle={async (val: number) => {

              }} date={poolData?.standard?.end_time || "2024/12/11 17:40:40"}></CountDownComp>
          }
        </div>

        <div
          style={{ border: '1px solid #26706A' }}
          className='w-full relative flex rounded-[20px] min-h-[192px] items-center bg-[#113A38] justify-center mt-[12px] '>
          {(currentTime < poolData?.standard?.start_time_uinx || currentTime > poolData?.standard?.end_time_uinx || !poolData?.standard) ?
            <p style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className=' text-center absolute text-[18px] leading-[22px] text-[#fff] font-bold'>{t("mining.next_pool_preparing")}</p> :
            <div onClick={() => {
              if (Object.prototype.toString.call(poolData?.standard_profits) != '[object Null]' && poolData?.standard_profits?.is_enabled) {
                navigate('/pool?type=0')
              } else {
                setType(0)
                setPromptDialog(true)
                setPromptText(t("mining.payment_standard_pool"))
              }
            }} className=' w-full p-[10px] pb-[15px] rounded-[20px] px-[10px]'>
              {
                poolData?.standard?.free_accelerator_config_remaining == 1 &&
                <div className='w-3 h-3 bg-[red] rounded-full absolute right-1 -top-1'></div>
              }
              <div className='flex justify-center items-center w-full'>
                <svg width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                      <stop stopColor="#00E49F" offset="0%"></stop>
                      <stop stopColor="#54ADFF" offset="100%"></stop>
                    </linearGradient>
                  </defs>
                  <g id="优化页面" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="06-挖矿主页" transform="translate(-108.000000, -390.000000)" fill="url(#linearGradient-1)">
                      <path d="M113.534659,399.744644 L111.678975,400.720235 C111.190131,400.977236 110.585504,400.789289 110.328503,400.300445 C110.226164,400.105784 110.190849,399.882816 110.228026,399.666058 L110.58243,397.599724 C110.638068,397.27533 110.530519,396.94433 110.294833,396.714593 L108.793554,395.251207 C108.39807,394.865706 108.389978,394.232593 108.775479,393.837109 C108.928988,393.679626 109.13013,393.577138 109.347767,393.545514 L111.422484,393.24404 C111.748195,393.196711 112.02976,392.992142 112.175422,392.696998 L113.103264,390.816986 C113.347686,390.321732 113.947312,390.118393 114.442566,390.362815 C114.639778,390.460146 114.799406,390.619773 114.896736,390.816986 L115.824578,392.696998 C115.97024,392.992142 116.251805,393.196711 116.577516,393.24404 L118.652233,393.545514 C119.198778,393.624931 119.577459,394.132374 119.498041,394.678919 C119.466417,394.896556 119.36393,395.097699 119.206446,395.251207 L117.705167,396.714593 C117.469481,396.94433 117.361932,397.27533 117.41757,397.599724 L117.771974,399.666058 C117.865335,400.210395 117.499747,400.727351 116.955411,400.820712 C116.738653,400.857889 116.515685,400.822574 116.321025,400.720235 L114.465341,399.744644 C114.174017,399.591486 113.825983,399.591486 113.534659,399.744644 Z" id="星形备份-11"></path>
                    </g>
                  </g>
                </svg>
                <p className=' text-style-1 text-[20px]  mx-2 !leading-[18px] font-bold'>{t("mining.standard_pool")}</p>
                <svg width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                      <stop stopColor="#00E49F" offset="0%"></stop>
                      <stop stopColor="#54ADFF" offset="100%"></stop>
                    </linearGradient>
                  </defs>
                  <g id="优化页面" stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
                    <g id="06-挖矿主页" transform="translate(-108.000000, -390.000000)" fill="url(#linearGradient-1)">
                      <path d="M113.534659,399.744644 L111.678975,400.720235 C111.190131,400.977236 110.585504,400.789289 110.328503,400.300445 C110.226164,400.105784 110.190849,399.882816 110.228026,399.666058 L110.58243,397.599724 C110.638068,397.27533 110.530519,396.94433 110.294833,396.714593 L108.793554,395.251207 C108.39807,394.865706 108.389978,394.232593 108.775479,393.837109 C108.928988,393.679626 109.13013,393.577138 109.347767,393.545514 L111.422484,393.24404 C111.748195,393.196711 112.02976,392.992142 112.175422,392.696998 L113.103264,390.816986 C113.347686,390.321732 113.947312,390.118393 114.442566,390.362815 C114.639778,390.460146 114.799406,390.619773 114.896736,390.816986 L115.824578,392.696998 C115.97024,392.992142 116.251805,393.196711 116.577516,393.24404 L118.652233,393.545514 C119.198778,393.624931 119.577459,394.132374 119.498041,394.678919 C119.466417,394.896556 119.36393,395.097699 119.206446,395.251207 L117.705167,396.714593 C117.469481,396.94433 117.361932,397.27533 117.41757,397.599724 L117.771974,399.666058 C117.865335,400.210395 117.499747,400.727351 116.955411,400.820712 C116.738653,400.857889 116.515685,400.822574 116.321025,400.720235 L114.465341,399.744644 C114.174017,399.591486 113.825983,399.591486 113.534659,399.744644 Z" id="星形备份-11"></path>
                    </g>
                  </g>
                </svg>
              </div>

              <div className='w-full flex items-start justify-between mt-[15px]'>
                <div className='flex-1 flex justify-start items-start'>
                  <img className='w-[18px] h-[18px]' src={mining_icon} alt="" />
                  <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.total_profits")}:</span>
                </div>
                <div className='text-[20px] leading-6 text-[#fff] font-bold flex items-end  justify-center'>
                  <p className='text-style-6 !text-[20px] font-bold !leading-[18px] pr-[8px]'> {FormattingTwoNumber(poolData?.standard?.total_profits || 0)} </p>
                  <p className='text-style-6 !text-[12px] !leading-[16px]'> $ </p>
                  <p className='text-style-6 !text-[14px] font-bold !leading-[16px]'> SAI </p>
                </div>

              </div>
              <div className='w-full flex items-start justify-between my-[10px]'>
                <div className='flex-1 flex justify-start items-start'>
                  <img className='w-[18px]' src={speedwhiteImg} alt="" />
                  <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.total_efficiency")}:</span>
                </div>
                <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-style-1 text-[14px] leading-6 !font-bold flex items-end  justify-center'>
                  {poolData?.standard?.total_profit_coefficient}
                  <span className='!text-[12px] leading-[22px] ml-[2px]'>%</span>
                </div>

              </div>
              <div className='w-full flex items-start justify-between mb-[10px]'>
                <div className='flex-1 flex justify-start items-start'>
                  <img className='h-[18px] w-[18px]' src={personImg} alt="" />
                  <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.participants")}:</span>
                </div>
                <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-style-1 text-[14px] leading-6 !font-bold flex items-end  justify-center'>
                  {poolData?.standard?.participants}
                </div>

              </div>
              <div className='text-[12px] text-[#fff] leading-[15px] flex items-start font-bold'>
                <img src={star} alt="" />
                <div className='text-[12px] ml-2 text-[#fff] leading-[15px] font-bold text-left'>
                  {t("mining.additional_participant")}
                  &nbsp;<span className='text-style-6 font-bold !leading-[18px] text-[16px]'>2000&nbsp;</span><span className='text-style-6 font-bold !leading-[18px] text-[16px]'>$SAI</span>
                </div>
              </div>


            </div>
          }
          {/* <img className=' w-full' src={standardPool_bg} alt="" /> */}
        </div>
      </div>

      {poolData?.mining_sn > 2 &&
        <div>
          <div className={`flex justify-between items-center mt-[30px] pr-[12px]`}>
            <div className='w-[120px] text-white'>{t("mining.phase")} {poolData?.mining_sn}-2</div>
            {
              currentTime < poolData?.nft?.start_time_uinx ?
                <CountDownComp endHandle={async (val: number) => {
                  if (Math.floor(Math.abs(val / 1000)) < 1) {
                    await getData()
                  }

                }} date={poolData?.nft?.start_time}></CountDownComp>
                :

                <CountDownComp endHandle={async (val: number) => {

                }} date={poolData?.nft?.end_time || "2024/12/11 17:40:40"}></CountDownComp>
            }g
          </div>

          <div
            style={{ border: '1px solid #4875BE' }}
            className='w-full relative flex min-h-[192px] items-center bg-[#1C3050] rounded-[20px] justify-center mt-[12px] '>

            {(currentTime < poolData?.nft?.start_time_uinx || currentTime > poolData?.nft?.end_time_uinx || !poolData?.nft) ?
              <p style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className=' text-center absolute text-[18px] leading-[22px] text-[#fff] font-bold'>{t("mining.next_pool_preparing")}</p> :
              <div onClick={async () => {
                if (Object.prototype.toString.call(poolData?.nft_profits) != '[object Null]' && poolData?.nft_profits?.is_enabled) {
                  navigate('/pool?type=2')
                } else {
                  try {
                    const { msg, code } = await postNftPoolPay()
                    if (code == "0") {
                      navigate('/pool?type=2')
                    } else {
                      setPrompt(true)
                      setPromptText(msg)
                    }
                  } catch {
                  }
                }

              }} className=' w-full min-h-[192px]  p-[10px] pb-[15px]'>
                {
                  poolData?.nft?.free_accelerator_config_remaining == 1 && <div className='w-3 h-3 bg-[red] rounded-full absolute right-1 -top-1'></div>
                }
                <div className='flex justify-center items-center w-full'>
                  {[1, 2].map((el: any) => (
                    <svg key={`${el}-NFT-1`} width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                          <stop stopColor="#00E49F" offset="0%"></stop>
                          <stop stopColor="#54ADFF" offset="100%"></stop>
                        </linearGradient>
                      </defs>
                      <g id="优化页面" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="06-挖矿主页" transform="translate(-108.000000, -390.000000)" fill="url(#linearGradient-1)">
                          <path d="M113.534659,399.744644 L111.678975,400.720235 C111.190131,400.977236 110.585504,400.789289 110.328503,400.300445 C110.226164,400.105784 110.190849,399.882816 110.228026,399.666058 L110.58243,397.599724 C110.638068,397.27533 110.530519,396.94433 110.294833,396.714593 L108.793554,395.251207 C108.39807,394.865706 108.389978,394.232593 108.775479,393.837109 C108.928988,393.679626 109.13013,393.577138 109.347767,393.545514 L111.422484,393.24404 C111.748195,393.196711 112.02976,392.992142 112.175422,392.696998 L113.103264,390.816986 C113.347686,390.321732 113.947312,390.118393 114.442566,390.362815 C114.639778,390.460146 114.799406,390.619773 114.896736,390.816986 L115.824578,392.696998 C115.97024,392.992142 116.251805,393.196711 116.577516,393.24404 L118.652233,393.545514 C119.198778,393.624931 119.577459,394.132374 119.498041,394.678919 C119.466417,394.896556 119.36393,395.097699 119.206446,395.251207 L117.705167,396.714593 C117.469481,396.94433 117.361932,397.27533 117.41757,397.599724 L117.771974,399.666058 C117.865335,400.210395 117.499747,400.727351 116.955411,400.820712 C116.738653,400.857889 116.515685,400.822574 116.321025,400.720235 L114.465341,399.744644 C114.174017,399.591486 113.825983,399.591486 113.534659,399.744644 Z" id="星形备份-11"></path>
                        </g>
                      </g>
                    </svg>))}
                  <p className='text-style-1 text-[20px] !leading-[18px] font-bold mx-2'>{t("mining.nft_pool")}</p>
                  {[1, 2].map((el: any) => (
                    <svg key={`${el}-NFT-1-2`} width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                          <stop stopColor="#00E49F" offset="0%"></stop>
                          <stop stopColor="#54ADFF" offset="100%"></stop>
                        </linearGradient>
                      </defs>
                      <g id="优化页面" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="06-挖矿主页" transform="translate(-108.000000, -390.000000)" fill="url(#linearGradient-1)">
                          <path d="M113.534659,399.744644 L111.678975,400.720235 C111.190131,400.977236 110.585504,400.789289 110.328503,400.300445 C110.226164,400.105784 110.190849,399.882816 110.228026,399.666058 L110.58243,397.599724 C110.638068,397.27533 110.530519,396.94433 110.294833,396.714593 L108.793554,395.251207 C108.39807,394.865706 108.389978,394.232593 108.775479,393.837109 C108.928988,393.679626 109.13013,393.577138 109.347767,393.545514 L111.422484,393.24404 C111.748195,393.196711 112.02976,392.992142 112.175422,392.696998 L113.103264,390.816986 C113.347686,390.321732 113.947312,390.118393 114.442566,390.362815 C114.639778,390.460146 114.799406,390.619773 114.896736,390.816986 L115.824578,392.696998 C115.97024,392.992142 116.251805,393.196711 116.577516,393.24404 L118.652233,393.545514 C119.198778,393.624931 119.577459,394.132374 119.498041,394.678919 C119.466417,394.896556 119.36393,395.097699 119.206446,395.251207 L117.705167,396.714593 C117.469481,396.94433 117.361932,397.27533 117.41757,397.599724 L117.771974,399.666058 C117.865335,400.210395 117.499747,400.727351 116.955411,400.820712 C116.738653,400.857889 116.515685,400.822574 116.321025,400.720235 L114.465341,399.744644 C114.174017,399.591486 113.825983,399.591486 113.534659,399.744644 Z" id="星形备份-11"></path>
                        </g>
                      </g>
                    </svg>))}
                </div>

                <div className='w-full flex items-start justify-between mt-[15px]'>
                  <div className='flex-1 flex justify-start items-start'>
                    <img className='w-[18px] h-[18px]' src={mining_icon} alt="" />
                    <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.total_profits")}:</span>
                  </div>
                  <div className='text-[20px] leading-6 text-[#fff] font-bold flex items-end  justify-center'>
                    <p className='text-style-6 !text-[20px] font-bold !leading-[18px] pr-[8px]'> {FormattingTwoNumber(poolData?.nft?.total_profits || 0)} </p>
                    <p className='text-style-6 !text-[12px] !leading-[16px]'> $ </p>
                    <p className='text-style-6 !text-[14px] font-bold !leading-[16px]'> SAI </p>
                  </div>

                </div>
                <div className='w-full flex items-start justify-between my-[10px]'>
                  <div className='flex-1 flex justify-start items-start'>
                    <img className='w-[18px]' src={speedwhiteImg} alt="" />
                    <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.total_efficiency")}:</span>
                  </div>
                  <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-style-1 text-[14px] leading-6 !font-bold flex items-end  justify-center'>
                    {poolData?.nft?.total_profit_coefficient}
                    <span className='!text-[12px] leading-[22px] ml-[2px]'>%</span>
                  </div>

                </div>
                <div className='w-full flex items-start justify-between mb-[10px]'>
                  <div className='flex-1 flex justify-start items-start'>
                    <img className='h-[18px] w-[18px]' src={personImg} alt="" />
                    <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.participants")}:</span>
                  </div>
                  <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-style-1 text-[14px] leading-6 !font-bold flex items-end  justify-center'>
                    {poolData?.nft?.participants}
                  </div>

                </div>
                <div className='text-[12px] text-[#fff] leading-[15px] flex items-start font-bold'>
                  <img src={star} alt="" />
                  <div className='text-[12px] ml-2 text-[#fff] leading-[15px] font-bold text-left'>
                    {t("mining.additional_participant")}
                    &nbsp;<span className='text-style-6 font-bold !leading-[18px] text-[16px]'>3000&nbsp;</span><span className='text-style-6 font-bold !leading-[18px] text-[16px]'>$SAI</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <div>
        {/* <p className=' text-[20px] leading-[18px] font-bold text-[#fff] text-center  mt-5 mb-[10px]'>VIP Pool</p> */}
        <div className='flex justify-between items-center mt-[30px] pr-[12px]'>
          <div className='w-[120px] text-white'>{t("mining.phase")} {poolData?.mining_sn}-{poolData?.mining_sn > 2 ? 3 : 2}</div>
          {/* <CountDownComp date={currentTime > poolData?.vip?.start_time_uinx ? poolData?.vip?.end_time : "2022/09/10 00:00:00"}></CountDownComp> */}
          {
            currentTime < poolData?.vip?.start_time_uinx ?
              <CountDownComp endHandle={async (val: number) => {
                // if (Math.floor(Math.abs(val / 1000)) < 1) {
                //   await getData()
                // }

              }} date={poolData?.vip?.start_time}></CountDownComp>
              :

              <CountDownComp endHandle={async (val: number) => {

              }} date={poolData?.vip?.end_time || "2024/12/11 17:40:40"}></CountDownComp>
          }
        </div>
        <div
          style={{ border: '1px solid #267138' }}
          className='w-full relative flex rounded-[20px] min-h-[192px] items-center bg-[#09220F] justify-center mt-[12px]'>
          {currentTime < poolData?.vip?.start_time_uinx || currentTime > poolData?.vip?.end_time_uinx || !poolData?.vip ?
            <p style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className=' text-center absolute text-[18px] leading-[22px] text-[#fff] font-bold'>{t("mining.next_pool_preparing")}</p> :
            <div onClick={() => {
              if (Object.prototype.toString.call(poolData?.vip_profits) != '[object Null]' && poolData?.vip_profits?.is_enabled) {
                navigate('/pool?type=1')
              } else {
                setShowPayDialog(true)
              }
            }} className=' rounded-[20px] w-full min-h-[192px] p-[10px] pb-[15px]'>
              {
                poolData?.vip?.free_accelerator_config_remaining == 1 && <div className='w-3 h-3 bg-[red] rounded-full absolute right-1 -top-2'></div>
              }
              <div className='flex justify-center items-center w-full'>
                {
                  [1, 2, 3].map(item => {
                    if (item <= poolData?.mining_sn) {
                      return (
                        <svg className='ml-2' width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                          <defs>
                            <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                              <stop stopColor="#FFE600" offset="0%"></stop>
                              <stop stopColor="#FFAB00" offset="100%"></stop>
                            </linearGradient>
                          </defs>
                          <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="mining中2.0" transform="translate(-113.000000, -711.000000)" fill="url(#linearGradient-1)">
                              <path d="M118.534659,720.744644 L116.678975,721.720235 C116.190131,721.977236 115.585504,721.789289 115.328503,721.300445 C115.226164,721.105784 115.190849,720.882816 115.228026,720.666058 L115.58243,718.599724 C115.638068,718.27533 115.530519,717.94433 115.294833,717.714593 L113.793554,716.251207 C113.39807,715.865706 113.389978,715.232593 113.775479,714.837109 C113.928988,714.679626 114.13013,714.577138 114.347767,714.545514 L116.422484,714.24404 C116.748195,714.196711 117.02976,713.992142 117.175422,713.696998 L118.103264,711.816986 C118.347686,711.321732 118.947312,711.118393 119.442566,711.362815 C119.639778,711.460146 119.799406,711.619773 119.896736,711.816986 L120.824578,713.696998 C120.97024,713.992142 121.251805,714.196711 121.577516,714.24404 L123.652233,714.545514 C124.198778,714.624931 124.577459,715.132374 124.498041,715.678919 C124.466417,715.896556 124.36393,716.097699 124.206446,716.251207 L122.705167,717.714593 C122.469481,717.94433 122.361932,718.27533 122.41757,718.599724 L122.771974,720.666058 C122.865335,721.210395 122.499747,721.727351 121.955411,721.820712 C121.738653,721.857889 121.515685,721.822574 121.321025,721.720235 L119.465341,720.744644 C119.174017,720.591486 118.825983,720.591486 118.534659,720.744644 Z" id="星形备份-15"></path>
                            </g>
                          </g>
                        </svg>
                      )
                    }
                  })
                }
                <p className='text-style-6 !text-[20px] font-bold !leading-[18px] px-[8px]'>{t("mining.vip_pool")}</p>
                {
                  [1, 2, 3].map(item => {
                    if (item <= poolData?.mining_sn) {
                      return (
                        <svg className='ml-2' width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                          <defs>
                            <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                              <stop stopColor="#FFE600" offset="0%"></stop>
                              <stop stopColor="#FFAB00" offset="100%"></stop>
                            </linearGradient>
                          </defs>
                          <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="mining中2.0" transform="translate(-113.000000, -711.000000)" fill="url(#linearGradient-1)">
                              <path d="M118.534659,720.744644 L116.678975,721.720235 C116.190131,721.977236 115.585504,721.789289 115.328503,721.300445 C115.226164,721.105784 115.190849,720.882816 115.228026,720.666058 L115.58243,718.599724 C115.638068,718.27533 115.530519,717.94433 115.294833,717.714593 L113.793554,716.251207 C113.39807,715.865706 113.389978,715.232593 113.775479,714.837109 C113.928988,714.679626 114.13013,714.577138 114.347767,714.545514 L116.422484,714.24404 C116.748195,714.196711 117.02976,713.992142 117.175422,713.696998 L118.103264,711.816986 C118.347686,711.321732 118.947312,711.118393 119.442566,711.362815 C119.639778,711.460146 119.799406,711.619773 119.896736,711.816986 L120.824578,713.696998 C120.97024,713.992142 121.251805,714.196711 121.577516,714.24404 L123.652233,714.545514 C124.198778,714.624931 124.577459,715.132374 124.498041,715.678919 C124.466417,715.896556 124.36393,716.097699 124.206446,716.251207 L122.705167,717.714593 C122.469481,717.94433 122.361932,718.27533 122.41757,718.599724 L122.771974,720.666058 C122.865335,721.210395 122.499747,721.727351 121.955411,721.820712 C121.738653,721.857889 121.515685,721.822574 121.321025,721.720235 L119.465341,720.744644 C119.174017,720.591486 118.825983,720.591486 118.534659,720.744644 Z" id="星形备份-15"></path>
                            </g>
                          </g>
                        </svg>
                      )
                    }
                  })
                }
              </div>

              <div className='w-full flex items-start justify-between mt-[15px]'>
                <div className='flex-1 flex justify-start items-start'>
                  <img className='w-[18px] h-[18px]' src={mining_icon} alt="" />
                  <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.total_profits")}:</span>
                </div>
                <div className='text-[20px] leading-6 text-[#fff] font-bold flex items-end  justify-center'>
                  <p className='text-style-6 !text-[20px] font-bold !leading-[18px] pr-[8px]'> {FormattingTwoNumber(poolData?.vip?.total_profits || "0")} </p>
                  <p className='text-style-6 !text-[12px] !leading-[16px]'> $ </p>
                  <p className='text-style-6 !text-[14px] font-bold !leading-[16px]'> SAI </p>
                </div>

              </div>
              <div className='w-full flex items-start justify-between my-[10px]'>
                <div className='flex-1 flex justify-start items-start'>
                  <img className='h-[18px] w-[18px]' src={speedImg} alt="" />
                  <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.total_efficiency")}:</span>
                </div>
                <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-style-1 text-[14px] leading-6 !font-bold flex items-end  justify-center'>
                  {poolData?.vip?.total_profit_coefficient || 0}
                  <span className='!text-[12px] leading-[22px] ml-[2px]'>%</span>
                </div>

              </div>
              <div className='w-full flex items-start justify-between mb-[10px]'>
                <div className='flex-1 flex justify-start items-start'>
                  <img className='h-[18px] w-[18px]' src={personImg} alt="" />
                  <span className='text-white text-base ml-2' style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} >{t("mining.participants")}:</span>
                </div>
                <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-style-1 text-[14px] leading-6 !font-bold flex items-end  justify-center'>
                  {poolData?.vip?.participants}
                </div>

              </div>
              <div className='text-[12px] text-[#fff] leading-[15px] flex items-start font-bold'>
                <img src={star} alt="" />
                <div className='text-[12px] ml-2 text-[#fff] leading-[15px] font-bold text-left'>
                  {t("mining.additional_participant")}
                  &nbsp;<span className='text-style-6 font-bold !leading-[18px] text-[16px]'>5000&nbsp;</span><span className='text-style-6 font-bold !leading-[18px] text-[16px]'>$SAI</span>
                </div>
              </div>
            </div>}
        </div>
      </div>
      <div onClick={() => {
        navigate("/post-pool")
      }} className='flex justify-center items-center text-white my-[24px] underline'>
        <img className='w-[18px] h-[18px] mr-2' src={recordImg} alt="" />
        {t("mining.past_mining_pools")}</div>
      <RulesDialog textArr={miningRules} type='mining' title={t("mining.mining_rules")} dialog={rulesDialog} setDialog={setRulesDialog}></RulesDialog>
      {
        showPayDialog &&
        <PayDialog isNeedDialogSuccess={false} dataList={payLink}
          title={t("other.attention")}
          text={t("mining.payment_vip_pool")}
          text_1={t("mining.proceed_confirmation")}
          callBack={(val) => {
            if (val != 'close') {
              const toast = Toast.loading({
                message: t("other.loading"),
                forbidClick: true,
                duration: 0
              })
              setShowPayDialog(false)
              getData().then(res => {
                if (res.vip_profits) {
                  navigate('/pool?type=1')
                }
                toast.clear()
              }).catch(err => {
                toast.clear()
                setPrompt(true)
                setPromptText(t("mining.network_error"))
              })
            } else {
              setShowPayDialog(false)
            }
          }} />
      }
      <PromptDialog
        title={t("other.attention")}
        dialog={promptDialog}
        setDialog={setPromptDialog}
        isClose={true}
        callback={async () => {
          try {
            const { msg, code } = await postStandardPay()
            if (code == "0") {
              navigate('/pool?type=0')
            } else {
              setPrompt(true)
              setPromptText(msg)
            }
          } catch {
          }
        }}
        text={promptText}>
      </PromptDialog>
      <PromptDialog
        title={t("other.attention")}
        dialog={prompt}
        setDialog={setPrompt}
        isClose={true}
        callback={async () => {
        }}
        text={promptText}>
      </PromptDialog>
    </div >
  )

}
export default Mining